import { AnchoredContent, ContentParentLink } from '@/components'
import { StyledContent, StyledTitle } from '@/components/styles'
import addSoftHyphenation from '@/lib/addSoftHyphenation'
import generateBlocks from '@/lib/generateBlocks'
import { useTranslation } from "react-i18next";

export default function ArticlePage(props) {
  const { title, blocks } = props
  const { t } = useTranslation("global");

  return (
    <StyledContent withLine>
      <StyledContent.Container>
        <StyledContent.Columns>
          <ContentParentLink type="blog">{t('articles.title')}</ContentParentLink>

          <AnchoredContent arrow={false}
            navHeader={
              <StyledTitle size="large" mb="medium" as="h1">
                {addSoftHyphenation(title, 15)}
              </StyledTitle>
            }
          >
            {blocks && blocks.length > 0 && generateBlocks(blocks)}
          </AnchoredContent>
        </StyledContent.Columns>
      </StyledContent.Container>
    </StyledContent>
  )
}
